import {Covid19I18n} from '@/locales/base.message.locales';

export const covid_19: Covid19I18n = {
  help_people: 'Help people',
  hold_hands: 'Hold hands again',
  printer_3d: 'Use your 3d printer',
  produce_masks: 'Produce masks',
  send_hospitals: 'Send to hospitals',
  description: `<p>It was never so important to use the collective intelligence in response to the coronavirus pandemic.
<br/><br/>
Join us with the challenges of protecting health professionals, social assistance to poor communities and integrity of the supply and logistics chain.</p>`
};
